import axiosInstance from "./request";

export default {
  // 判断登录态
  checkLogin() {
    return axiosInstance.get("/login/V1/Web/checkLogin");
  },
  // 首页接口
  campaignHome(params) {
    return axiosInstance.get("/campaignv2/home", { params });
  },
  // 计价接口
  campaignCheck(data) {
    return axiosInstance.post("/campaignv2/check", data);
  },
  // 二级页接口
  campaignList(params) {
    return axiosInstance.get("/campaignv2/sublist", { params });
  },
  // 二级页加价购商品列表
  campaignIncList(data) {
    return axiosInstance.post("/campaignv2/incList", data);
  },
  // 新的idencode接口
  campaignPay(data) {
    return axiosInstance.post("/porder/v1/tool/idencode", data);
  },
  // 旧的idencode接口
  campaignPayOld(params) {
    return axiosInstance.get("/trade/PC/Order/IsCanBuy/index", { params });
  },
  // 重新计算获取加价购商品列表（新）
  calIncList(data) {
    return axiosInstance.post("/campaignv2/calIncList", data);
  },
  getTokenByCode(code) {
    return axiosInstance.get("/login/V1/Touch/getToken", {
      params: { code },
    });
  },
};
